import gql from "graphql-tag"

const ASSIGN_ROLES_QUERY = gql`
  query AssignRolesQuery {
    assignRoles
  }
`

export default ASSIGN_ROLES_QUERY
